<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryItems, activeIndex } = useUiMediaGallery(props.name)
</script>

<template>
  <div class="media-gallery-dots">
    <button
      v-for="item in galleryItems"
      :key="item.src"
      type="button"
      :data-dot="item.index"
      class="media-gallery-dots__dot"
      :class="{
        'media-gallery-dots__dot--active': activeIndex === item.index,
      }"
      @click="activeIndex = item.index"
    />
  </div>
</template>

<style>
@import url("~layers/components/Ui/MediaGallery/Dots.css");
</style>
